import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useGoBack from '@hooks/useGoBack';
import CloseLineIcon from '@icons/CloseLineIcon';
import { pressActionEffect } from '@styles/mixin';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function BottomSheetHeader({ children }:Props) {
    const goBack = useGoBack();
    return (
        <Container>
            {children && (
                <Text size='title' fontWeight='bold'>
                    {children}
                </Text>
            )}
            <CloseButton color={colors.gray9}
                size={30}
                onClick={goBack} />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--spacing-5);
    height: var(--spacing-16);
`;

const CloseButton = styled(CloseLineIcon)`
    position: absolute;
    right: var(--spacing-5);
    ${pressActionEffect}
`;

export default BottomSheetHeader;
